import {
  QldContractStage,
  NswContractStage,
} from '@urbanx/agx-ui-components';
import { useSelectedCampaign } from 'hooks/useSelectedCampaign';
import { Tabs } from 'types/Tabs';
import ResumeContractSubmission from './ResumeContractSubmission';
import ContractSubmitPanel from './ContractSubmitPanel';
import { getEnumValue } from 'helpers/enumHelper';
import {
  CampaignDetailModelState,
  ContractDetailModel,
  ContractStatuses,
} from '@urbanx/agx.campaigns.client';

interface ContractSubmissionInfoPanelProps {
  state: CampaignDetailModelState;
  contract: ContractDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const ContractSubmissionInfoPanel = ({
  state,
  contract,
  currentTab,
  mobile = false,
}: ContractSubmissionInfoPanelProps) => {
  const { selectedCampaign } = useSelectedCampaign();
  const { contractStage: stage } = contract;

  const resumeStages = [
    QldContractStage.ContractDraft,
    QldContractStage.BuyerSigning,
    QldContractStage.SignedByBuyer,
    QldContractStage.SignedByAllParties,
    QldContractStage.SubmissionIncomplete,
    NswContractStage.ContractDraft,
    NswContractStage.SalesAdviceDraft,
    NswContractStage.AwaitingExchange,
    NswContractStage.SubmissionIncomplete,
  ];

  const submitStages = [
    QldContractStage.Accepted,
    QldContractStage.Unconditional,
    QldContractStage.Terminated,
    QldContractStage.Settled,
    QldContractStage.BackUp,
    QldContractStage.PendingCompliance,
    NswContractStage.Accepted,
    NswContractStage.Unconditional,
    NswContractStage.Terminated,
    NswContractStage.Settled,
    NswContractStage.ContractRequested,
    NswContractStage.PendingSubmission,
    NswContractStage.PendingCompliance,
  ];

  if (!stage) throw new Error('Contract stage is undefined');

  const enumType =
    state === CampaignDetailModelState.QLD ? QldContractStage : NswContractStage;

  const contractStage = getEnumValue(enumType, stage) ?? stage;
  const nswContractStage =
    getEnumValue(NswContractStage, stage) ?? (stage as NswContractStage);

  const nswContractRequested =
    state === CampaignDetailModelState.NSW &&
    nswContractStage === NswContractStage.ContractRequested;
  const nswPendingSubmission =
    state === CampaignDetailModelState.NSW &&
    (stage === ContractStatuses.PendingSubmission ||
      nswContractStage === NswContractStage.PendingSubmission);

  if (selectedCampaign && contractStage && resumeStages.includes(contractStage))
    return (
      <ResumeContractSubmission
        currentTab={currentTab}
        campaign={selectedCampaign}
        contract={contract}
        lastUpdate={contract.lastUpdate}
        mobile={mobile}
      />
    );
  if (selectedCampaign && contractStage && submitStages.includes(contractStage))
    return (
      <ContractSubmitPanel
        campaign={selectedCampaign}
        currentTab={currentTab}
        showDownload={!nswContractRequested}
        showSubmit={nswPendingSubmission}
      />
    );

  return null;
};

export default ContractSubmissionInfoPanel;
